import cx from 'classnames'
import React from 'react'

type Props = {
  /** Label to show on the input. */
  label?: string
  /** Description to show on the input. */
  description?: string | React.ReactNode
  /** True if the input field is required */
  isRequired?: boolean
  /** Externally defined className */
  className?: string
  /** On change callback */
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  /** Indicates whether checkbox is checked o not. */
  defaultChecked?: boolean
  /** Test id. */
  'data-testid'?: string
}

/**  Renders a checkbox input. */
const CheckBox = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement> & Props
>(
  (
    { label, description, isRequired, className, defaultChecked, ...rest },
    ref,
  ) => {
    return (
      <div className={cx(rest.disabled && 'cursor-not-allowed opacity-50')}>
        <label
          className={cx(
            className,
            rest.disabled && 'cursor-not-allowed',
            'inline-flex items-center text-foreground-normal',
          )}
        >
          <input
            ref={ref}
            type="checkbox"
            className="h-4 w-4 rounded border-foreground-subtle bg-background text-primary focus:ring-primary focus:ring-offset-background"
            defaultChecked={defaultChecked}
            {...rest}
          />
          {label && <span className="ml-2">{label}</span>}
          {isRequired && <span className="text-red-500">{` *`}</span>}
        </label>

        {description && (
          <p className="text-sm text-foreground-subtle">{description}</p>
        )}
      </div>
    )
  },
)
CheckBox.displayName = 'CheckBox'
CheckBox.defaultProps = {
  isRequired: false,
}

export default CheckBox
